import { IoCloseCircleOutline, IoNotificationsCircle } from 'react-icons/io5';
import { Header2 } from '../../components/header';
import { CxControle, TanqueStyled } from '../../styles/tanques';
import { useContext, useEffect, useRef, useState } from 'react';
import { TanqueContextC } from '../../contexts/contextTanque';
import {
  GraficosByTanque,
  GraficosTanquesC,
  ModalAlertas,
  ModalConfimacaoBombaTanque,
  VazaoModal,
} from './modals';
import { SquareLoading } from '../../components/loaders';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { LuPower, LuPowerOff } from 'react-icons/lu';
import { PiArrowsClockwiseBold } from 'react-icons/pi';
import { IoMdWifi } from 'react-icons/io';
import { HeaderMobile } from '../../components/mobileHeader';
import { toast } from 'react-toastify';

export const Tanque = () => {
  const {
    setModalAlertas,
    modalAlertas,
    alertaList,
    modalStatus,
    tanquesList,
    setModalStatus,
    setTanquesList,
    modalConfimetionBomba,
    setModalConfimationBomba,
    idControlerBomba,
    setIdControlerBomba,
    modalVazao,
    setModalVazao,
  } = useContext(TanqueContextC);

  const { socket } = useContext(HomeContext);

  const { headerApi } = useContext(HomeContext);

  const [graficoName, setGraficoName] = useState('Todos os Tanques');
  const [tanqueId, setTanqueId] = useState(null);
  const [mensagemModal, setmensagemModal] = useState(null);
  const [alertasList, setAlertas] = useState([]);
  const [statusTanques, setStatusTanques] = useState([]);
  const [modalVazalSave, setModalVazaoSave] = useState([]);

  const ListTanques = async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const response = await apiJalles.get(`tanque/LeituraTodos/${idUnidade}`, headerApi);
      setTanquesList(response.data);
      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const listAlertasTanque = async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');
      const response = await apiJalles.get(`/alertas/tanque/Leitura/${idUnidade}`, headerApi);
      setAlertas(response.data);
      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const verifStatusGtwPoco = async () => {
    try {
      const status = await apiJalles.get(`/users/tanques/list`, headerApi);
      setStatusTanques(status.data);
      // if (idGTw != null) {
      // }
    } catch (error) {
      console.log('erro na verificação do status do tanque', error);
    }
  };

  const handlePing = (tanque) => {
    socket.emit('ping_gateway', {
      id: tanque.id,
      nome_tanque: tanque.nome_tanque,
      gtw_tanque: tanque.gtw_tanque,
    });
    toast.success('Comando Feito com sucesso', {
      position: 'top-right',
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'dark',
    });
  };

  useEffect(() => {
    ListTanques();
    verifStatusGtwPoco();
    listAlertasTanque();
  }, []);

  const tanquesRef = useRef(tanquesList);

  useEffect(() => {
    tanquesRef.current = tanquesList;
  }, [tanquesList]);

  useEffect(() => {
    if (!socket) return;

    const handleTanqueUpdate = (data) => {
      ListTanques();
      // console.log('recebendo tanqueUpdate', data);
    };

    const handleBombaEdit = (data) => {
      // console.log('recebendo BombaTanque_edit', data);
      ListTanques();
    };

    const handleControlerEdit = (data) => {
      // console.log('recebendo ControlerBomba_edit', data);
    };

    const handleUpdateControler = () => {
      ListTanques();
    };

    const handleChangedUser = () => {
      verifStatusGtwPoco();
    };

    const handleCreateAlert = () => {
      listAlertasTanque();
    };

    const handlePong = (Data) => {
      // console.log('recebendo pong_gateway', Data);
      // console.log('Lista de tanques:', tanquesRef.current);

      const pongTanque = tanquesRef.current?.find((e) => e.id === Data.tankID);

      if (!pongTanque) return;

      if (Data.status === 'success') {
        toast.info(`Gateway Comunicado com Tanque: ${pongTanque.nome_tanque}`);
      } else {
        toast.error(`Gateway não conseguiu comunicar com Tanque: ${pongTanque.nome_tanque}`);
      }
    };

    socket.on('tanqueUpdate', handleTanqueUpdate);
    socket.on('BombaTanque_edit', handleBombaEdit);
    socket.on('ControlerBomba_edit', handleControlerEdit);
    socket.on('update_ControlerBombaTanque', handleUpdateControler);
    socket.on('changed_user', handleChangedUser);
    socket.on('creat_alerta', handleCreateAlert);
    socket.on('pong_gateway', handlePong);

    // 🔥 IMPORTANTE: cleanup quando desmontar
    return () => {
      socket.off('tanqueUpdate', handleTanqueUpdate);
      socket.off('BombaTanque_edit', handleBombaEdit);
      socket.off('ControlerBomba_edit', handleControlerEdit);
      socket.off('update_ControlerBombaTanque', handleUpdateControler);
      socket.off('changed_user', handleChangedUser);
      socket.off('creat_alerta', handleCreateAlert);
      socket.off('pong_gateway', handlePong);
    };
  }, [socket]);

  useEffect(() => {
    if (modalAlertas || modalConfimetionBomba) {
      document.body.classList.add('modal-open'); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove('modal-open'); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalAlertas, modalConfimetionBomba]);

  if (!tanquesList) {
    return (
      <TanqueStyled>
        <SquareLoading />
      </TanqueStyled>
    );
  }

  return (
    <TanqueStyled>
      <Header2 />
      <HeaderMobile />
      {modalAlertas && <ModalAlertas />}
      {modalVazao && <VazaoModal vazao={modalVazalSave} />}

      {modalConfimetionBomba && <ModalConfimacaoBombaTanque mensagem={mensagemModal} />}

      <section className="sectionTanque">
        <div className="avisos">
          <IoNotificationsCircle onClick={() => setModalAlertas(!modalAlertas)} />
        </div>

        <div className="containerSuperior">
          {graficoName !== 'Todos os Tanques' && (
            <span
              onClick={() => {
                setGraficoName('Todos os Tanques');
              }}
              className="close"
            >
              <IoCloseCircleOutline />
            </span>
          )}

          <div className="graficos">
            {graficoName === 'Todos os Tanques' ? (
              <GraficosTanquesC
                TanquesData={tanquesList
                  .sort((a, b) => a.nome_tanque.localeCompare(b.nome_tanque))
                  .filter((tanque) => tanque.ativo && tanque.painel !== 3)}
              />
            ) : (
              <GraficosByTanque TanqueDataId={tanqueId} />
            )}
          </div>
          <div className="containerAlertas">
            <div className="alertas">
              <h4>Últimos alertas dos tanques</h4>
              <div>
                {alertasList.results &&
                  alertasList.results.map((alert) => {
                    const data = new Date(alert.createdAt);

                    // Data no formato DD/MM/YYYY
                    const dia = data.toLocaleDateString('pt-BR');

                    // Hora no formato HH:MM
                    const hora = data.toLocaleTimeString('pt-BR', {
                      hour: '2-digit',
                      minute: '2-digit',
                    });
                    return (
                      <span key={alert.id}>
                        {`${dia} ${hora} -
                        ${alert.mensagem}`}
                      </span>
                    );
                  })}
              </div>
            </div>
            <div className="buttons">
              <button
                onClick={() => {
                  setGraficoName('Todos os Tanques');
                }}
                className="btnStatus"
              >
                {graficoName != 'Todos os Tanques' && 'Tanque'} {graficoName}
              </button>
              {/* <button
                className="btnStatus"
                onClick={() => setModalStatus(!modalStatus)}
              >
                Status dos Tanques
              </button> */}
            </div>
          </div>
        </div>

        <div className="containerInferior">
          <ul>
            {tanquesList
              .filter((tanque) => tanque.ativo)
              .sort((a, b) => a.nome_tanque.localeCompare(b.nome_tanque))
              .map((tanques) => {
                let statusTanque = false;
                let statusGtw = false;

                let statusTanqueObj = statusTanques.find((e) => e.tanque === tanques.id);

                if (statusTanqueObj == null) {
                  statusTanqueObj = statusTanques.find((e) => {
                    return e.tanque === tanques.usuario_tanque;
                  });
                }

                const statusGtwObj = statusTanques.find((e) => {
                  if (e.gateway !== null) {
                    return e.gateway === tanques.gtw_tanque;
                  }
                  return false;
                });

                if (statusTanqueObj?.online) {
                  statusTanque = statusTanqueObj.online;
                }

                if (statusGtwObj?.online) {
                  statusGtw = statusGtwObj.online;
                }

                return (
                  <li key={tanques.id}>
                    <h3
                      onClick={() => {
                        setGraficoName('Todos os Tanques');
                        setTanqueId(tanques.id);
                        setGraficoName(tanques.nome_tanque);
                      }}
                    >
                      {tanques.nome_tanque}
                    </h3>
                    <div className="containerInfos">
                      <IoMdWifi
                        className={`gtwStatus ${statusGtw ? 'gtwStatusON' : 'gtwStatusOFF'}`}
                      />
                      <div className={`ping ${!statusGtw && 'PingGTWOFF'}`}>
                        <button onClick={() => handlePing(tanques)} disabled={!statusGtw}>
                          Ping Lora...
                        </button>
                      </div>
                      <div className={statusTanque ? 'tanqueOn' : 'tanqueOff'} />
                      <div className="conteinerLimite">
                        <div className="infos">
                          {tanques.painel != 3 && (
                            <>
                              <div className="info">
                                <p>Nível</p>
                                <span>{tanques.nivel_atual}%</span>
                              </div>

                              <div className="barraNivelVerticalWrapper">
                                <span>100%</span>

                                <div className="barraNivelVertical">
                                  <div
                                    className="barraNivelVerticalAtual"
                                    style={{
                                      '--nivel': `${Math.min(
                                        Math.max(Number(tanques.nivel_atual) || 0, 0),
                                        100,
                                      )}%`,
                                    }}
                                  />
                                </div>

                                <span>0%</span>
                              </div>
                            </>
                          )}
                          <div className="info">
                            <p>Bombas</p>
                            <span>{tanques.bombas.length}</span>
                          </div>
                          {tanques.bombas.length > 0 &&
                            tanques.bombas.map((bomba, index) => {
                              return (
                                <>
                                  <div className="info">
                                    <p>Corrente B{index + 1}</p>
                                    <span>{bomba.corrente} A</span>
                                  </div>
                                  <div className="info">
                                    <p>Horímetro B{index + 1}</p>
                                    <span>
                                      {`${Math.floor(bomba.horimetro)}:${Math.floor(
                                        (bomba.horimetro % 1) * 60,
                                      )
                                        .toString()
                                        .padStart(2, '0')}`}
                                    </span>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                        <div className="conteinerStatus">
                          <div className="status">
                            <div>
                              <p>Modo de Controle</p>
                            </div>
                            {tanques.painel == 0 && (
                              <div className="controle">
                                <div className="divControler">
                                  <CxControle
                                    activo={
                                      tanques.automatico == 1 ? 'rgb(53, 53, 53)' : 'transparent'
                                    }
                                  ></CxControle>
                                  <p>Remoto</p>
                                </div>

                                <div className="divControler">
                                  <CxControle
                                    activo={
                                      tanques.automatico == 0 ? 'rgb(53, 53, 53)' : 'transparent'
                                    }
                                  ></CxControle>
                                  <p>Manual</p>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="status">
                            {tanques.bombas.length > 0 &&
                              tanques.bombas.map((bomba, index) => {
                                const comandoBomba = bomba.bombaControler[0].comando;
                                return (
                                  <div key={index} className="Bombas">
                                    {(tanques.painel === 1 || tanques.painel === 3) && (
                                      <div className="status">
                                        <div className="controle">
                                          <div className="divControler">
                                            <CxControle
                                              activo={
                                                bomba.automatico == 1
                                                  ? 'rgb(53, 53, 53)'
                                                  : 'transparent'
                                              }
                                            ></CxControle>
                                            <p>Remoto</p>
                                          </div>

                                          <div className="divControler">
                                            <CxControle
                                              activo={
                                                bomba.automatico == 0
                                                  ? 'rgb(53, 53, 53)'
                                                  : 'transparent'
                                              }
                                            ></CxControle>
                                            <p>Manual</p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <span>Bomba - {index + 1}</span>

                                    <button
                                      disabled={
                                        comandoBomba ||
                                        (tanques.painel === 0 && tanques.automatico === 0) ||
                                        ((tanques.painel === 1 || tanques.painel === 3) &&
                                          bomba.automatico === 0)
                                      }
                                      onClick={() => {
                                        setIdControlerBomba(bomba.bombaControler[0].id);
                                        setModalConfimationBomba(true);
                                        setmensagemModal(bomba.status ? 'Deligar' : 'Ligar');
                                      }}
                                      className={
                                        tanques.painel == 1 ||
                                        (tanques.painel == 3 &&
                                          bomba.automatico == 0 &&
                                          'desativado')
                                      }
                                    >
                                      {comandoBomba ? (
                                        <PiArrowsClockwiseBold
                                          className={`icon ${comandoBomba && 'butonOff'}`}
                                        />
                                      ) : bomba.status == 1 ? (
                                        <LuPower className="icon IconeOn" />
                                      ) : (
                                        <LuPowerOff className="icon" />
                                      )}
                                      {bomba.status == 1 ? 'Ligada' : 'Desligada'}
                                    </button>
                                    {bomba.vazao != null && (
                                      <>
                                        <button
                                          onClick={() => {
                                            setModalVazao(true);
                                            setModalVazaoSave([
                                              bomba.bombaControler[0].id,
                                              bomba.vazao,
                                            ]);
                                          }}
                                        >
                                          Vazão
                                        </button>
                                        <div className="info">
                                          <span>{bomba.vazao}%</span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </section>
    </TanqueStyled>
  );
};
